import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Drawer, Heading } from "@foris/avocado-suite";
import { emitEvent } from "@common/hooks/useListenEvent";
import CreationForm from "../../pages/CreationForm";
import styles from "./packagesCreationDrawer.module.scss";

interface PackagesCreationDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onCreatePackage: (dryRun?: boolean, skipValidations?: boolean) => void;
}

const PackagesCreationDrawer = ({
  isOpen,
  onClose,
  onCreatePackage,
}: PackagesCreationDrawerProps) => {
  const { t } = useTranslation();
  const [isValid, setIsValid] = useState(false);

  const handleCreatePackage = () => {
    emitEvent("on:submit", {
      target: "package-creation",
    });
  };

  return (
    <Drawer
      className={styles.packagesCreationDrawer}
      contentClassName={styles.packagesCreationDrawer_content}
      isOpen={isOpen}
      onClose={onClose}
      title={<Heading type="h3">{t("create-package.create-and-add-package")}</Heading>}
      footer={
        <div className={styles.packagesCreationDrawer_footer}>
          <Button variant="ghost" onClick={onClose}>
            {t("create-package.btn-cancel")}
          </Button>
          <Button onClick={handleCreatePackage} disabled={!isValid}>
            {t("create-package.btn-create")}
          </Button>
        </div>
      }
      closeOnOverlayClick
    >
      {isOpen && (
        <CreationForm
          className={styles.packagesCreationDrawer_form}
          onSubmit={(dryRun, skipValidations) => onCreatePackage(dryRun, skipValidations)}
          onValidForm={setIsValid}
          showActionButtons={false}
        />
      )}
    </Drawer>
  );
};

export default PackagesCreationDrawer;
